import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { IS_MOBILE } from '@app/modules/core/tokens/app.tokens';

@Component({
  selector: 'app-privacy-policy-ar',
  templateUrl: './privacy-policy-ar.component.html',
  styleUrls: ['./privacy-policy-ar.component.sass'],
  encapsulation: ViewEncapsulation.ShadowDom,
  standalone: false
})
export class PrivacyPolicyArComponent {

  constructor(
    @Inject(IS_MOBILE) public isMobile: boolean,
  ) { }

}
